var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUmEnsaioSobreACegueira(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 156,
    viewBox: "0 0 26 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6245 0.993999L0 1.04639L0.332811 156L25.9573 155.948L25.6245 0.993999Z",
    fill: "#7FC6BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0014 74.9727C11.9476 74.9727 11.1156 74.2579 11.1156 73.3526L10.9492 15.6977C10.9492 14.7924 11.7812 14.0776 12.835 14.0776C13.8888 14.0776 14.7208 14.7924 14.7208 15.6977L14.8872 73.3526C14.8317 74.2579 13.9998 74.9727 13.0014 74.9727Z",
    fill: "#CE5E58"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmEnsaioSobreACegueira);
export default __webpack_public_path__ + "static/media/um-ensaio-sobre-a-cegueira.e157d19b.svg";
export { ForwardRef as ReactComponent };